import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=118dd482&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=118dd482&prod&scoped=true&lang=scss"
import style1 from "./FooterComponent.vue?vue&type=style&index=1&id=118dd482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118dd482",
  null
  
)

export default component.exports